module.exports = __webpack_public_path__ + "img/area.22ddebfd.svg";